import { useState } from 'react';
import { Form, Formik } from 'formik';
import { useParams } from 'react-router-dom';

import Card from '@luna-protocol/core/src/components/Card/Card';
import CardRow from '@luna-protocol/core/src/components/CardRow/CardRow';
import { applicantDetailsSchema } from './ApplicantDetailsSchema';
import styles from './ApplicantDetails.module.scss';
import { useGetApplicant, ApplicantRequest, ApplicantRes } from '../../queries/useGetApplicant.ts';

type ApplicantDetailsProps = {
  isCoapplicant?: boolean;
  customerID?: string;
  className?: string;
};

const ApplicantDetails = ({ isCoapplicant = false, customerID, className }: ApplicantDetailsProps) => {
  const { loan_application_id: loanApplicationID } = useParams();
  const [isEditable, setIsEditable] = useState(false);
  const { data, isLoading } = useGetApplicant({ loanApplicationID, isCoapplicant, customerID } as ApplicantRequest);

  const onSubmit = (values: ApplicantRes) => {
    console.log('values', values);
    console.log(loanApplicationID);
    setIsEditable(!isEditable);
  };

  return (
    <div className={className}>
      <p>{!isCoapplicant ? 'Applicant' : 'Co-Applicant'} Details</p>
      {data && !isLoading && (
        <Formik initialValues={data} onSubmit={onSubmit} validationSchema={applicantDetailsSchema} enableReinitialize>
          {({ values, setFieldValue, touched, errors }) => (
            <Form className={styles.applicantDetails__form}>
              <Card className={styles.applicantDetails__card}>
                <CardRow
                  label="First Name"
                  inputName="first_name"
                  value={values.first_name}
                  isEditMode={isEditable}
                  handleChange={event => setFieldValue('first_name', event.target.value)}
                  touched={touched.first_name}
                  error={errors.first_name}
                />
                <CardRow
                  label="Last Name"
                  inputName="last_name"
                  value={values.last_name}
                  isEditMode={isEditable}
                  handleChange={event => setFieldValue('last_name', event.target.value)}
                  touched={touched.last_name}
                  error={errors.last_name}
                />
                <CardRow
                  label="Address"
                  inputName="address_lines"
                  value={values.address_lines && `${values.address_lines[0]} ${values.address_lines[1] ?? ''}`}
                  isEditMode={isEditable}
                  handleChange={event => setFieldValue('address_lines', event.target.value)}
                  touched={touched.address_lines}
                  error={errors?.address_lines && !!touched?.address_lines ? errors?.address_lines[0] : undefined}
                />
                <CardRow
                  label="City"
                  inputName="city"
                  value={values.city}
                  isEditMode={isEditable}
                  handleChange={event => setFieldValue('city', event.target.value)}
                  touched={touched.city}
                  error={errors.city}
                />
                <CardRow
                  label="State"
                  inputName="state"
                  value={values.state}
                  isEditMode={isEditable}
                  handleChange={event => setFieldValue('state', event.target.value)}
                  touched={touched.state}
                  error={errors.state}
                />
                <CardRow
                  label="Zip Code"
                  inputName="zip_code"
                  value={values.zip_code}
                  isEditMode={isEditable}
                  handleChange={event => setFieldValue('zip_code', event.target.value)}
                  touched={touched.zip_code}
                  error={errors.zip_code}
                />
                <CardRow
                  label="Phone Number"
                  inputName="cell_phone_number"
                  value={values.cell_phone_number}
                  isEditMode={isEditable}
                  handleChange={event => setFieldValue('cell_phone_number', event.target.value)}
                  touched={touched.cell_phone_number}
                  error={errors.cell_phone_number}
                />
                <CardRow
                  label="Home Phone Number"
                  inputName="home_phone_number"
                  value={values.home_phone_number}
                  isEditMode={isEditable}
                  handleChange={event => setFieldValue('home_phone_number', event.target.value)}
                  touched={touched.home_phone_number}
                  error={errors.home_phone_number}
                />
                <CardRow
                  label="Date of Birth"
                  inputName="date_of_birth"
                  inputType="date"
                  value={values.date_of_birth !== '0001-01-01' ? values.date_of_birth : ''}
                  handleChange={event => setFieldValue('date_of_birth', event.target.value)}
                  touched={touched.date_of_birth}
                  error={errors.date_of_birth}
                />
                <CardRow
                  label="Social Security Number"
                  inputName="social_security_number"
                  value={values.social_security_number}
                  inputType={isEditable ? 'password' : 'text'}
                  handleChange={event => setFieldValue('social_security_number', event.target.value)}
                  touched={touched.social_security_number}
                  error={errors.social_security_number}
                />
                <CardRow
                  label="Email Address"
                  inputName="email_address"
                  value={values.email_address}
                  isEditMode={isEditable}
                  handleChange={event => setFieldValue('email_address', event.target.value)}
                  touched={touched.email_address}
                  error={errors.email_address}
                />
              </Card>
            </Form>
          )}
        </Formik>
      )}
    </div>
  );
};

export default ApplicantDetails;
